/* If the view passes the controls located in header, shows a secondary navigator fixed to top */

function stickyNavigator() {
	const headerBottom = $('#header').outerHeight() + $('#header').position().top,
		windowPosition = $(window).scrollTop();

	if (windowPosition > headerBottom)
		$('#navigator').slideDown(200);
	else
		$('#navigator').slideUp(200);
};

$(window).on('load resize scroll', () => {
	stickyNavigator();
});
